import { Component, HostListener, Inject, OnDestroy, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { HistoryEntryDto } from 'src/app/entities/OperationLogDto';
import * as L from 'leaflet';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'app-device-map-dialog',
  standalone: false,
  templateUrl: './device-map-dialog.component.html',
  styleUrl: './device-map-dialog.component.css'
})
export class DeviceMapDialogComponent implements OnInit, OnDestroy, AfterViewInit {
  backdropClickSub!: Subscription;

  @ViewChild('mapContainer')
  mapContainer!: ElementRef;

  constructor(
    private dialogRef: MatDialogRef<DeviceMapDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public historyEntry: HistoryEntryDto,
    private languageService: LanguageService
  ) {
  }

  ngOnInit(): void {
    this.backdropClickSub = this.dialogRef.backdropClick().subscribe(() => {
      this.onCancel();
    });
  }

  ngOnDestroy(): void {
    this.backdropClickSub?.unsubscribe();
  }

  ngAfterViewInit(): void {
    const map = L.map(this.mapContainer.nativeElement);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '&copy; OpenStreetMap contributors' })
    .addTo(map);

    const bounds = L.latLngBounds([]);

    // Device marker
    if (this.historyEntry.DeviceLatitude != null && this.historyEntry.DeviceLongitude != null) {
      const deviceLatLng: L.LatLngExpression = [
        this.historyEntry.DeviceLatitude,
        this.historyEntry.DeviceLongitude
      ];

      L.marker(deviceLatLng, { icon: this.getIcon('assets/img/van.png') })
      .addTo(map)
      .bindPopup(this.languageService.getTranslation('Devices.DevicePosition'));

      bounds.extend(deviceLatLng);
    }

    // Client marker
    if (this.historyEntry.ClientLatitude != null && this.historyEntry.ClientLongitude != null) {
      const clientLatLng: L.LatLngExpression = [
        this.historyEntry.ClientLatitude,
        this.historyEntry.ClientLongitude
      ];

      L.marker(clientLatLng, { icon: this.getIcon('assets/img/user.png') })
      .addTo(map)
      .bindPopup(this.languageService.getTranslation('Devices.ClientPosition'));

      bounds.extend(clientLatLng);
    }

    // Adjust map view
    if (bounds.isValid()) {
      map.fitBounds(bounds, { padding: [50, 50] });
    } else { // fallback if no markers exist
      map.setView([45.4642, 9.19], 5);
    }
  }

  getIcon(iconUrl: string) : L.Icon {
    return L.icon({
      iconUrl: iconUrl,
      iconSize: [32, 32],
      iconAnchor: [16, 32]
    });
  }
  
  @HostListener('document:keydown.escape', ['$event'])
  onEscKey(event: Event) {
    this.onCancel();
  }

  onCancel() {
    this.onClosing();
  }

  onClosing() {
    this.dialogRef.close();
  }

}
